// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var WorkersLogo = function WorkersLogo(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M4.111.972L6 4.4 4.265 7.519a1.061 1.061 0 000 .963L6 11.6l-1.889 3.428a2.14 2.14 0 01-.847-.809l-3-5.2a2.133 2.133 0 010-2.041l3-5.2a2.14 2.14 0 01.847-.806zm8.626.809l3 5.2a2.133 2.133 0 010 2.041l-3 5.2a1.975 1.975 0 01-1.733 1H8l3.735-6.739a1.061 1.061 0 000-.963L8 .78h3a1.975 1.975 0 011.736 1.001z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      opacity: ".5",
      d: "M5 15.22a2.284 2.284 0 01-.886-.193l3.7-6.7a.662.662 0 000-.655l-3.7-6.7A2.284 2.284 0 015 .78h3l3.735 6.739a1.061 1.061 0 010 .963L8 15.22z"
    }))
  );
};

export default WorkersLogo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/WorkersLogo.js
// module id = 1063
// module chunks = 0